import React from 'react';

const CloseIcon = props => (
  <svg xmlns='http://www.w3.org/2000/svg' width={10} height={10} fill='none' {...props}>
    <path
      fill='#000'
      d='M1.063 10 0 8.937 3.938 5 0 1.062 1.063 0 5 3.938 8.938 0 10 1.063 6.062 5 10 8.938 8.937 10 5 6.062 1.062 10Z'
    />
  </svg>
);

export default CloseIcon;
